import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_PAGE } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetPage = function*(Param) {
  yield takeLatest(GET_PAGE, workerGetPage);
};

function* workerGetPage(Param) {
  const result = yield call(getPage, Param);
  yield put({ type: "SET_PAGE", json: result.data });
}

function getPage(Param) {
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.get(apiUrl + "pages/pages?" + Param.param, options).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}
